import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/signup-flow')({
  // Redirect to main page for single-user VM mode
  beforeLoad: () => {
    throw redirect({ to: '/', search: { slide: undefined} })
  },
  component: () => null,
})